"use strict";
angular.module("headerModule", [])
	.controller("headerCtrl", ["$scope", "$location", "localStorageService", "$interval", "$q", "$state", "httpService", "$stateParams", function($scope, $location, localStorageService, $interval, $q, $state, httpService, $stateParams) {
		initStatus();
		initData();

		function initStatus() {
			$scope.info = {};
			$scope.data = {
				platformlogo:'',
				searchKeyword: ''
			};
			$scope.authentication = {
				0: '未审核',
				1: '已认证',
				2: '认证失败',
				3: '二次审核'
			}
			$scope.authenticationClass = {
				0: 'unaudited',
				1: 'green',
				2: 'failure',
				3: 'twoAudit'
			}
		}
		/**
		 * [getseconddomain description]获得admin 登录配置信息
		 * 
		 * @return {[type]} [description]
		 */
		function getseconddomain() {
			var deffer = $q.defer();
			var params = {
				domainPrefix: '123'
			}
			httpService.http("/mcnww/web/tenant/getSecondDomain.do", params, "get").then(function(data) {
				if(data.data.platformlogo==null){
					$scope.data.platformlogo ='images/logo.png';
				}else{
					$scope.data.platformlogo = JSON.parse(data.data.platformlogo)[0];
				}
				if(data.data.platformName==null) {
					$scope.data.platformName = '通讯员平台';
				} else {
					$scope.data.platformName = data.data.platformName;
				}
				deffer.resolve();
			});
			return deffer.promise;
		}

		function initData() {
			getLogin();
			intervalGetMessage();
			getseconddomain();
			window.addEventListener("storage", function(e) {
				if(e.key === "ls.readMessage") {
					unReadMessages();
				}
			});
			$scope.$on("readMessage", function() {
				unReadMessages();
			});
			$scope.$on('changeHeadKeyWord', function(event, v) {
				$scope.data.searchKeyword = v;
			});
		}
		/**
		 * [intervalGetMessage description] 间隔时间请求未读信息
		 * @return {[type]} [description]
		 */
		function intervalGetMessage() {
			var myInterval = $interval(unReadMessages, 30000);
			$scope.$on("$destroy", function() {
				$interval.cancel(myInterval);
			});
		}
		/**
		 * [goTobackstage description] 进入后台
		 * @return {[type]} [description]
		 */
		$scope.goTobackstage = function() {
			var href = $state.href("backstage");
			window.open(href);
		};
		/**
		 * [goToInformation description] 进入修改资料
		 * @return {[type]} [description]
		 */
		$scope.goToInformation = function() {
			var href = $state.href("index.settings.mainOperationInfo");
			window.open(href);
		};
		/**
		 * [goToInformationUgc description] 进入ugc修改资料
		 * @return {[type]} [description]
		 */
		$scope.goToInformationUgc = function() {
			var href = $state.href("index.settings.modifydata");
			window.open(href);
		}
		/**
		 * [goToMessage description] 进入消息
		 * @return {[type]} [description]
		 */
		$scope.goToMessage = function() {
			var href = $state.href("index.settings.message");
			window.open(href);
		};
		/**
		 * [logOut description] 注销
		 * @return {[type]} [description]
		 */
		$scope.logOut = function() {
			httpService.http("/mcnww/web/user/logout.do", "", "post").then(function() {
				httpService.notLogin = false;
				$state.go("login", {
					orgurl: $state.current.name,
					orgparams: $stateParams
				});
				sessionStorage.clear();
			});
		};
		/**
		 * [getLogin description] 获取登入详细
		 * @return {[type]} [description]
		 */

		function getLogin() {
			httpService.http("/mcnww/web/user/getLoginUser.do", "", "post").then(function(data) {
				$scope.info = data.loginUser;
				$scope.isAdmin = data.isAdmin;
				var time = new Date().getTime();
				if(data.loginUser.logo) {
					$scope.headPic = angular.globalConfig.pictureServer + data.loginUser.logo + '?v=' + time;
				} else {
					$scope.headPic = './images/uperroe.png';
				}
				if(data.loginUser.userType == 1) {
					$scope.message = true;
					unReadMessages();
				} else {
					$scope.message = false;
				}
				sessionStorage.setItem("loginUser",JSON.stringify(data.loginUser));
				$scope.status = data.auditStatus;
			});
		}
		/**
		 * [unReadMessages description] 获取消息数字
		 * @return {[type]} [description]
		 */
		function unReadMessages() {
			httpService.http("/mcnww/web/message/unReadMessages.do", "", "post").then(function(data) {
				$scope.unReadmessages = data.unReadmessages;
			});
		}
		/**
		 * 同步数据
		 * @return {[type]} [description]
		 */
		$scope.$on("sucessLogo", function() {
			getLogin();
		});
		$scope.$on("pgcSucessLogo", function() {
			getLogin();
		});

		// 搜索
		$scope.fullSearchFn = function(ev) {
			if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
				var keywords = $scope.data.searchKeyword.trim();
				/* keywords !== '' &&  */$state.go('search.fullsearch', {
					keywords: keywords
				});
			}
		}
		if (/^\/search\/fullsearch\?/.test($location.url())) {
			var searchObj = $location.search();
			if (typeof searchObj.keywords === 'string') $scope.data.searchKeyword = searchObj.keywords;
		}
	}]);